<template>
	<button
		class="inline-flex items-center gap-2 transition-all"
		
		v-ripple
		type="button"
		v-tooltip.bottom="
			type === 'new'
				? 'Add New'
				: type === 'newImage'
				? 'Add New Illustration'
				: type === 'slideshow'
				? props.toolTipLabel
				: type === 'newmodels'
				? 'Add Models'
				: type === 'editmodels'
				? 'Edit Models'
				: type === 'imagelist'
				? 'Edit Illustration(s)'
				: type === 'readCallAssistantButton'
				? props.toolTipLabel
				: type === 'feedbackList'
				? 'View Feedback Collection'
				: type === 'feedback'
				? props.toolTipLabel
				: type === 'notification'
				? props.toolTipLabel
				: type === 'print'
				? props.toolTipLabel
				: type === 'details'
				? props.toolTipLabel
				: type === 'finishassistantMode'
				? 'Recall [Author] Personal Assistant'
				: type === 'complainceAssistantMode'
				? 'Re(call) Compliancy Assistant!'
				: type === 'helpSupportAssistant'
				? 'Ask Support Assistant'
				: type === 'reportassistantMode'
				? 'Ask Reporting Assistant'
				: type === 'feedbackAssistantMode'
				? 'Feedback Assistant'
				: type === 'examinerAssistantMode'
				? 'Call Examiner Assistant'
				: type === 'assistantMode'
				? props.toolTipLabel
				: type === 'lngReviewEdit'
				? props.toolTipLabel ?? 'Edit'
				: type === 'processingassistantMode'
				? 'Content is being processed'
				: type === 'configAssistantMode'
				? 'Configure'
				: 'Edit'
		"
		@click="handleClick"
	>
		<i v-if="type !== 'assistantMode' && type !== 'complainceAssistantMode' && type !== 'helpSupportAssistant' && type !== 'reportassistantMode' && type !== 'processingassistantMode' && type !== 'examinerAssistantMode' && type !== 'readCallAssistantButton' && type !== 'feedbackAssistantMode' && type !== 'print' && type !== 'details'"
			:class="
				type === 'new'
					? 'tabler:plus'
					: type === 'newImage'
					? 'tabler:photo-plus'
					: type === 'imageattr'
					? 'tabler:photo-edit'
					: type === 'imagelist'
					? 'tabler:library-photo'
					: type === 'newmodels'
					? 'tabler:plus'
					: type === 'slideshow'
					? 'tabler:presentation'
					: type === 'configAssistantMode'
					? 'tabler:settings'
					: type === 'finishassistantMode'
					? 'tabler:message-2-question'
					: type === 'feedback'
					? 'tabler:message-2-question'
					: type === 'notification'
					? props.icon
					: type === 'lngReviewEdit'
					? props.icon ?? 'tabler:edit'
					: type === 'feedbackList'
					? 'tabler:message-user'
					: 'tabler:edit'
			"
			class="w-5 h-5"
		></i>
		<span
			v-if="
				type === 'editmodels' ||
				type === 'assistantMode' ||
				type === 'complainceAssistantMode' ||
				type === 'helpSupportAssistant' ||
				type === 'feedbackAssistantMode' ||
				type === 'reportassistantMode' ||
				type === 'examinerAssistantMode' ||
				type === 'processingassistantMode' ||
				type === 'readCallAssistantButton' ||
				type === 'feedbackList' ||
				type === 'details' ||
				type === 'print' ||
				type === 'notification'
			"
			:class="type === 'assistantMode' || type === 'complainceAssistantMode' || type === 'helpSupportAssistant' || type === 'reportassistantMode' || type === 'examinerAssistantMode' || type === 'processingassistantMode' || type === 'readCallAssistantButton' || type === 'feedbackAssistantMode' ? 'flex items-center gap-2 mr-2' : 'flex items-center'"
		>
			<div class="rounded-full w-[35px] h-[25px] relative" v-if="type == 'assistantMode'">
				<span class="absolute left-0 right-0 mr-2">	
					<EwIcon icon="i-fa6-solid:people-arrows flex" class="w-25px h-25px"/>
					<img class="rounded-full w-15px h-15px right-[-6px] top-[-6px] absolute" src="../assets/images/reto-krapf-236x300.jpg" alt="">
				</span>
			</div>
			<div class="rounded-full w-[35px] h-[25px] relative" v-if="type == 'complainceAssistantMode'">
				<span class="absolute left-0 right-0 mr-2">	
					<EwIcon icon="i-fa6-solid:people-arrows flex" class="w-25px h-25px"/>
					<EwIcon icon="tabler:file-check flex" class="rounded-full w-15px h-15px right-[-12px] top-[-4px] absolute"/>
				</span>
			</div>
			<div class="rounded-full w-[35px] h-[25px] relative" v-if="type == 'helpSupportAssistant'">
				<span class="absolute left-0 right-0 mr-2">	
					<EwIcon icon="i-fa6-solid:people-arrows flex" class="w-25px h-25px"/>
					<EwIcon icon="tabler:books flex" class="rounded-full w-15px h-15px right-[-12px] top-[-4px] absolute"/>
				</span>
			</div>
			<div class="rounded-full w-[35px] h-[20px] relative" v-if="type == 'readCallAssistantButton'">
				<span class="absolute left-0 right-0 mr-2">	
					<EwIcon icon="i-fa6-solid:people-arrows flex" class="w-20px h-20px"/>
					<EwIcon icon="tabler:message-2 flex" class="rounded-full w-20px h-20px right-[-12px] top-[-4px] absolute"/>
				</span>
			</div>
			<div class="rounded-full w-[35px] h-[25px] relative" v-if="type == 'reportassistantMode'">
				<span class="absolute left-0 right-0 mr-2">	
					<EwIcon icon="i-fa6-solid:people-arrows flex" class="w-25px h-25px"/>
					<EwIcon icon="tabler:chart-infographic flex" class="rounded-full w-20px h-20px right-[-12px] top-[-4px] absolute"/>
				</span>
			</div>
			<div class="rounded-full w-[35px] h-[25px] relative" v-if="type == 'feedbackAssistantMode'">
				<span class="absolute left-0 right-0 mr-2">	
					<EwIcon icon="i-fa6-solid:people-arrows flex" class="w-25px h-25px"/>
					<EwIcon icon="tabler:mail-question flex" class="rounded-full w-20px h-20px right-[-12px] top-[-4px] absolute"/>
				</span>
			</div>
			<div class="rounded-full w-[35px] h-[25px] relative" v-if="type == 'examinerAssistantMode'">
				<span class="absolute left-0 right-0 mr-2">	
					<EwIcon icon="i-fa6-solid:people-arrows flex" class="w-25px h-25px"/>
					<EwIcon icon="tabler:message-2-question flex" class="rounded-full w-20px h-20px right-[-12px] top-[-4px] absolute"/>
				</span>
			</div>
			<div v-if="type === 'processingassistantMode'" class="spinnerAssistant"></div>
				{{ buttonName }}
			</span>
			<span v-if="type === 'slideshow' || type === 'feedback'" class="hidden md:inline">{{ buttonName }}</span>


	</button>
</template>

<script setup lang="ts">
import { inject, computed } from 'vue'
import { useRouter } from 'vue-router'
import { SetEditingContextFn, type EditingType } from '@/types'
import { messages } from '@/assets/language'
import { useAppStore } from '@/stores/app-store'

// props duhet të jetë sipër
const props = defineProps<{
  id: string
  type?: EditingType
  overrideURL?: string
  buttonLabel?: string
  toolTipLabel?: string
  headerTitle?: string
  icon?: string
}>()

const { currentLng } = useAppStore()
const router = useRouter()

const labels = computed(() => {
  const key = currentLng.value as keyof typeof messages
  return messages[key] ?? {}
})

const setEditingContext = inject(SetEditingContextFn)

function handleClick() {
  if (props.type === 'details') {
    router.push({ name: 'details', params: { id: props.id } })
  } else if (setEditingContext && props.id && props.type) {
    setEditingContext(props.id, props.type, props.overrideURL || '', props.headerTitle)
  }
}


const buttonName = computed(() => {
  if (props.buttonLabel) return props.buttonLabel
  if (props.toolTipLabel) return props.toolTipLabel
  switch (props.type) {
    case 'new':
      return 'New Review Post'
    case 'newmodels':
      return 'Add Models'
    case 'editmodels':
      return 'Edit Models'
    case 'slideshow':
      return 'New Slideshow'
    case 'feedback':
      return labels.value.feedbackBtn
    case 'notification':
      return labels.value.notificationBtn
    case 'feedbackList':
      return labels.value.feedbackBtn
    case 'print':
      return labels.value.printBtn
    case 'details':
      return labels.value.readmode
    case 'processingassistantMode':
      return 'Content is being processed'
    case 'assistantMode':
      return '[Workflow State]'
    case 'finishassistantMode':
      return 'Recall Assistant'
    case 'configAssistantMode':
      return 'Configure Assistant'
    default:
      return ''
  }
})
</script>
